import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 物件状態 */
enum ArticleStatus {
  underContract = '1',
  expired = '2',
  contractCanceled = '3',
}

const nameConfig = {
  underContract: new Map([[Locale.ja, '契約中']]),
  expired: new Map([[Locale.ja, '満了済']]),
  contractCanceled: new Map([[Locale.ja, '解約済']]),
};

const toEnum = rawValueToEnum(ArticleStatus, ArticleStatus.underContract);
const toDisplay = enumToName(ArticleStatus, nameConfig);
const toDisplayWithPrefix = enumToName(ArticleStatus, nameConfig, { prefix: true });

export const articleStatus = {
  enum: ArticleStatus,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ArticleStatus };
